// $(document).on('change', '[name="country"]' , function () {
//     let findState =  $('[name="country"]').parent().next('.state');
//
//     //$(this).find('[name="state"]')
//     findState.find(('[name="state"]')).removeAttr('required')
//
//
//     if(findState.find('.required-mark').length){
//         $('[for="state"]').html('State');
//     }
//
// });

const handelPaymentError = () => {
    UX.utils.mutationObserver('.payment', {childList: true, subtree: true}, UX.payment.afterAddresVerify, null, true);
};

const handleContinueBtn = () => {
    const continueBtn = document.querySelector('.continue-btn');
    continueBtn?.removeEventListener('click', handelPaymentError);
    continueBtn?.addEventListener('click', handelPaymentError);
};
$('body').on('click', '.verify-address', function (e) {
    let $this = $(this),
        link = $this.data('link'),
        countryName = '',
        stateName = '',
        hasState = false,
        selectedCountry = $('[name="country"]').val(),
        selectedState = $('[name="state"]').val(),
        requiredFields = {
            field1: $('[name="zipCode"]'),
            field2: $('[name="country"] option:selected').parent(),
            field3: $('[name="address1"]'),
            field4: $('[name="surname"]'),
            field5: $('[name="givennames"]'),
            field6: $('[name="phone"]'),
            field7: $('[name="countryCode"]'),
        },
        requiredFieldsLength = Object.keys(requiredFields).length;

    e.preventDefault();

    $.each(requiredFields, function (key, item) {
        let fieldWrapper = null;
        const fieldName = item[0]?.getAttribute('name');

        if (fieldName === 'countryCode' || fieldName === 'phone') {
            fieldWrapper = document.querySelector(`[data-notification='phone']`);
        } else {
            fieldWrapper = document.querySelector(`[data-notification=${fieldName}]`);
        }

        const fieldLabel = fieldWrapper?.querySelector('.label');
        const fieldInfo = fieldLabel?.querySelector('.field-info');
        const message = fieldLabel?.querySelector('.message');

        if (fieldWrapper && item.val() === '') {
            item[0]?.setAttribute('aria-invalid', 'true');
            fieldLabel?.classList.add('error');
            fieldInfo?.classList.remove('hidden');
            if (fieldInfo) {
                fieldInfo.style.display = 'inline-block';
            }
            if (message) {
                message.textContent = 'is missing';
            }

            $('.billing-info.error').removeClass('hidden');
            $('.billing-info.error').css('display', 'block');
            $('.billing-info.error').html('<p class="errorMsgBox">The following fields are required:</p>');
            item.focus();
        } else if (fieldWrapper) {
            Object.keys(requiredFields).splice(key, 1);
            item[0]?.setAttribute('aria-invalid', 'false');

            const inputName = item[0]?.getAttribute('name');
            const countryCodeValue = document.getElementById('countryCode')?.value;
            const phoneValue = document.getElementById('phone')?.value;
            const isPhoneOrCountryCode = inputName === 'phone' || inputName === 'countryCode';
            const hasValues = phoneValue !== '' && countryCodeValue !== '';

            if (!isPhoneOrCountryCode || hasValues) {
                fieldLabel?.classList.remove('error');
                fieldInfo?.classList.add('hidden');
                if (fieldInfo) {
                    fieldInfo.style.display = 'none';
                }
                if (message) {
                    message.textContent = '';
                }
            }

            requiredFieldsLength -= 1;
        } else {
            requiredFieldsLength -= 1;
        }
    });

    if (requiredFieldsLength === 0) {
        $('.billing-info.error').addClass('hidden');
        $('.billing-info.error').css('display', 'none');
        $('.billing-info.error p').empty();

        $this.attr('disabled', 'disabled'); // to avoid multiple requests

        $('[name="country"] option').each(function (e) {
            if ($(this).val() === selectedCountry) {
                if (selectedCountry === 'US' || selectedCountry === 'IN' || selectedCountry === 'CA') {
                    hasState = true;
                    $('[name="state"] option ').each(function (e) {
                        if ($(this).val() === selectedState) {
                            stateName = $(this).text();
                        }
                    });
                }
                countryName = $(this).text();
            }
        });

        $.get(link, {
            address1: $('[name="address1"]').val(),
            address2: $('[name="address2"]').val(),
            country: countryName,
            zipCode: $('[name="zipCode"]').val(),
            city: $('[name="city"]').val(),
            state: stateName,
        })
            .done(function (data, textStatus, jqXHR) {
                if (typeof data === 'string') {
                    data = JSON.parse(data);
                }
                $this.removeAttr('disabled');

                if (jqXHR.status === 200 && data.AD_Suggestive_Response) {
                    if (!$('.billing-address-error').hasClass('hidden')) {
                        $('.billing-address-error').addClass('hidden');
                    }

                    let itemsNum = data.AD_Suggestive_Response.length;
                    if (itemsNum === 1) {
                        if (data.AD_Suggestive_Response[0]['AD_MATCH_CODE'] === 'Q3') {
                            window.adobeDataLayer && UX.adobeDigitalData.eCommerce.AddressVerification();
                            handelPaymentError();
                        }

                        if (!$this.parent().hasClass('hidden')) {
                            $this.parent().attr('style', '');
                            $this.parent().addClass('hidden');
                        }

                        if (!$('.select-address').hasClass('hidden')) {
                            $('.select-address').addClass('hidden');
                        }

                        $('[name="zipCode"]').val(data.AD_Suggestive_Response[0].POSTAL_CODE);
                        let cityVal =
                            data.AD_Suggestive_Response[0].CITY && data.AD_Suggestive_Response[0].CITY !== 'NULL'
                                ? data.AD_Suggestive_Response[0].CITY
                                : '';
                        $('[name="city"]').val(cityVal);

                        $('[name="address1"]').val(data.AD_Suggestive_Response[0].ADDRESS_LINE_1);

                        let address2Val =
                            data.AD_Suggestive_Response[0].ADDRESS_LINE_2 &&
                            data.AD_Suggestive_Response[0].ADDRESS_LINE_2 !== 'NULL'
                                ? data.AD_Suggestive_Response[0].ADDRESS_LINE_2
                                : '';
                        $('[name="address2"]').val(address2Val);

                        $('[name="city"]').attr('required', 'required');

                        if (!$('[for="city"]').find('.required-mark').length) {
                            $('[for="city"]').append('<span class="required-mark" aria-hidden="true">*</span>');
                        }

                        if (hasState) {
                            $('[name="state"]').attr('required', 'required');
                            if (!$('[for="state"]').find('.required-mark').length) {
                                $('[for="state"]').append('<span class="required-mark" aria-hidden="true">*</span>');
                            }
                        }

                        // do it later:
                        $('[name="country"]').val(data.AD_Suggestive_Response[0].COUNTRY_ISO2); //do we need to update it and state
                        $('[name="country"] option:selected').text(data.AD_Suggestive_Response[0].COUNTRY_NAME);
                        if (hasState) {
                            $('[name="state"]').val(data.AD_Suggestive_Response[0].REGION_CD); //state note in the response
                            $('[name="state"] option:selected').text(data.AD_Suggestive_Response[0].REGION_NM);
                        }

                        $('.continue-btn').removeClass('hidden');
                        $('.verify-address-wrapper').addClass('hidden');
                        $('[data-bind="submitBilling"]').trigger('click');
                        $this.parent().addClass('hidden');

                        $(document).on('keyup', '[name="address1"] , [name="city"] , [name="zipCode"]', function () {
                            $this.parent().removeClass('hidden');
                            $this.val('Re-verify');
                            handleContinueBtn();
                            $('.actions').css('display', 'inline');
                            $('.actions').parent().addClass('float-right');
                        });

                        $(document).on('change', '[name="country"] , [name="state"]', function () {
                            $this.parent().removeClass('hidden');
                            $this.val('Re-verify');

                            $('.actions').css('display', 'inline');
                            $('.actions').parent().addClass('float-right');
                        });
                    } else if (itemsNum >= 2) {
                        if (!$this.parent().hasClass('hidden')) {
                            $this.parent().attr('style', '');
                            $this.parent().addClass('hidden');
                        }
                        if (!$('.continue-btn').hasClass('hidden')) {
                            $('.continue-btn').addClass('hidden');
                            $('.continue-btn').attr('style', '');
                        }

                        let addressLine1 = '',
                            addressLine1Data = '',
                            addressLine2 = '',
                            addressLine2Data = '',
                            city = '',
                            cityData = '',
                            country = '',
                            countryData = '',
                            state = '',
                            stateData = '',
                            postalCode = '',
                            postalCodeData = '',
                            addressDropdown = $('.billingAddressFields #selectAddress'),
                            countryISO2 = '',
                            countryISO2Data = '',
                            regionCode = '',
                            regionCodeData = '';

                        $('.select-address').removeClass('hidden');
                        $('.select-address label').attr('aria-live', 'polite');
                        if (hasState) {
                            $('.select-address').css('margin-top', 'toRem(25)');
                        }

                        addressDropdown.empty().append('<option selected>Select an address</option>');
                        $('.original-address').parent().removeClass('hidden');
                        $this.parent().addClass('hidden');

                        //to doooo
                        // edit concatenation
                        //ternary if statement

                        $.each(data.AD_Suggestive_Response, function (key, item) {
                            let dataCollection = '',
                                optionText = '';

                            if (item.ADDRESS_LINE_1) {
                                addressLine1 = item.ADDRESS_LINE_1;
                                addressLine1Data = `data-address1="${addressLine1}"`;
                                optionText += `${addressLine1}, `;
                            }
                            if (item.ADDRESS_LINE_2 && item.ADDRESS_LINE_2 !== 'NULL') {
                                addressLine2 = item.ADDRESS_LINE_2;
                                addressLine2Data = `data-address2="${addressLine2}"`;
                                optionText += `${addressLine2}, `;
                            }
                            if (item.CITY) {
                                city = item.CITY;
                                cityData = `data-city="${city}"`;
                                optionText += `${city}, `;
                            }
                            if (item.COUNTRY_NAME) {
                                country = item.COUNTRY_NAME;
                                countryData = `data-country="${country}"`;
                                optionText += `${country}, `;
                            }
                            if (item.COUNTRY_ISO2) {
                                countryISO2 = item.COUNTRY_ISO2;
                                countryISO2Data = `data-countryISO2="${countryISO2}"`;
                            }
                            if (hasState && item.REGION_NM) {
                                state = item.REGION_NM;
                                stateData = `data-state="${state}"`;
                                optionText += `${state}, `;
                            }
                            if (hasState && item.REGION_CD) {
                                regionCode = item.REGION_CD;
                                regionCodeData = `data-regionCode="${regionCode}"`;
                                optionText += `${regionCode}, `;
                            }
                            if (item.POSTAL_CODE) {
                                postalCode = item.POSTAL_CODE;
                                postalCodeData = `data-zipcode="${postalCode}"`;
                                optionText += `${postalCode}`;
                            }

                            dataCollection = `${addressLine1Data} ${addressLine2Data} ${cityData} ${countryData} ${countryISO2Data} ${stateData} ${regionCodeData} ${postalCodeData}`;
                            addressDropdown.append(`<option ${dataCollection}>${optionText}</option>`);
                            $('.continue-btn').addClass('hidden').attr('style', '');
                        });
                        const selectAddress = document.querySelector('.billingAddressFields #selectAddress');
                        selectAddress?.addEventListener(
                            'change',
                            function () {
                                $('[name="address1"]').val($(this).children('option:selected').data('address1'));
                                $('[name="address2"]').val($(this).children('option:selected').data('address2'));
                                $('[name="zipCode"]').val($(this).children('option:selected').data('zipcode'));
                                $('[name="city"]').val($(this).children('option:selected').data('city'));

                                $('[name="country"]').val($(this).children('option:selected').data('countryiso2'));
                                $('[name="country"] option:selected').text(
                                    $(this).children('option:selected').data('country')
                                );

                                if (hasState) {
                                    $('[name="state"]').val($(this).children('option:selected').data('regioncode'));
                                    $('[name="state"] option:selected').text(
                                        $(this).children('option:selected').data('state')
                                    );
                                }

                                $('.continue-btn').removeClass('hidden');
                                handleContinueBtn();
                                $('.original-address').parent().addClass('hidden');

                                $('.select-address').addClass('hidden');

                                window.adobeDataLayer && UX.adobeDigitalData.eCommerce.AddressVerification();
                            },
                            {once: true}
                        );

                        $(document).on('click', '.original-address', function () {
                            $('.continue-btn').removeClass('hidden');
                            handleContinueBtn();
                            $('.continue-btn').attr('style', '');

                            $('[name="city"]').attr('required', 'required');
                            if (!$('[for="city"]').find('.required-mark').length) {
                                $('[for="city"]').append('<span class="required-mark" aria-hidden="true">*</span>');
                            }

                            if (hasState) {
                                $('[name="state"]').attr('required', 'required');

                                if (!$('[for="state"]').find('.required-mark').length) {
                                    $('[for="state"]').append(
                                        '<span class="required-mark" aria-hidden="true">*</span>'
                                    );
                                }
                            }
                        });

                        $(document).on('keyup', '[name="address1"] , [name="city"] , [name="zipCode"]', function () {
                            $this.parent().removeClass('hidden');
                            $this.val('Re-verify');
                            $('.continue-btn').removeClass('hidden');
                            handleContinueBtn();
                            $('.original-address').parent().addClass('hidden');

                            $('.actions').css('display', 'inline');
                            $('.actions').parent().addClass('float-right');
                            $('.original-address').parent().addClass('hidden');
                        });

                        $(document).on('change', '[name="country"] , [name="state"]', function () {
                            $this.parent().removeClass('hidden');
                            $this.val('Re-verify');
                            $('.continue-btn').removeClass('hidden');
                            handleContinueBtn();
                            $('.original-address').parent().addClass('hidden');

                            $('.actions').css('display', 'inline');
                            $('.actions').parent().addClass('float-right');
                            $('.original-address').parent().addClass('hidden');
                        });
                    }
                } else if (jqXHR.status === 200 && data.err.message && !data.AD_Suggestive_Response) {
                    $('.billing-address-error').removeClass('hidden');
                    $('.billing-address-error').attr('aria-live', 'polite');
                    $('.billing-address-error').html(
                        '<i aria-hidden="true" class="icon-info---Material-Icon"></i> <span>' +
                            data.err.message +
                            ' <span>'
                    );
                    $('.continue-btn').removeClass('hidden');
                    handleContinueBtn();
                    $this.parent().addClass('hidden');

                    $('[name="city"]').attr('required', 'required');
                    if (!$('[for="city"]').find('.required-mark').length) {
                        $('[for="city"]').append('<span class="required-mark" aria-hidden="true">*</span>');
                    }

                    if (hasState) {
                        $('[name="state"]').attr('required', 'required');

                        if (!$('[for="state"]').find('.required-mark').length) {
                            $('[for="state"]').append('<span class="required-mark" aria-hidden="true">*</span>');
                        }
                    }

                    $(document).on('keyup', '[name="address1"] , [name="city"] , [name="zipCode"]', function () {
                        $this.parent().removeClass('hidden');
                        $this.val('Re-verify');
                        $('.continue-btn').removeClass('hidden');
                        handleContinueBtn();

                        $('.actions').css('display', 'inline');
                        $('.actions').parent().addClass('float-right');
                        $('.original-address').parent().addClass('hidden');
                    });

                    $(document).on('change', '[name="country"] , [name="state"]', function () {
                        $this.parent().removeClass('hidden');
                        $this.val('Re-verify');
                        $('.continue-btn').removeClass('hidden');
                        handleContinueBtn();

                        $('.actions').css('display', 'inline');
                        $('.actions').parent().addClass('float-right');
                        $('.original-address').parent().addClass('hidden');
                    });
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.log('error occure on the server ' + errorThrown); // eslint-disable-line no-console
                $this.removeAttr('disabled');

                if (jqXHR.status === 503) {
                    $('.billing-address-error').removeClass('hidden');
                    $('.billing-address-error').html(
                        '<i aria-hidden="true" class="icon-info---Material-Icon"></i> <span> ' +
                            jqXHR.responseJSON.err.message +
                            '<span>'
                    );
                    $('.continue-btn').removeClass('hidden');
                    handleContinueBtn();
                    $this.parent().addClass('hidden');
                    $('[name="city"]').attr('required', 'required');
                    if (!$('[for="city"]').find('.required-mark').length) {
                        $('[for="city"]').append('<span class="required-mark" aria-hidden="true">*</span>');
                    }

                    if (hasState) {
                        $('[name="state"]').attr('required', 'required');
                        if (!$('[for="state"]').find('.required-mark').length) {
                            $('[for="state"]').append('<span class="required-mark" aria-hidden="true">*</span>');
                        }
                    }

                    $(document).on('keyup', '[name="address1"], [name="city"], [name="zipCode"]', function () {
                        $this.parent().removeClass('hidden');
                        $this.val('Re-verify');
                        $('.continue-btn').removeClass('hidden');
                        handleContinueBtn();
                        $('.actions').css('display', 'inline');
                        $('.actions').parent().addClass('float-right');
                        $('.original-address').parent().addClass('hidden');
                    });

                    $(document).on('change', '[name="country"] , [name="state"]', function () {
                        $this.parent().removeClass('hidden');
                        $this.val('Re-verify');
                        $('.continue-btn').removeClass('hidden');
                        handleContinueBtn();
                        $('.actions').css('display', 'inline');
                        $('.actions').parent().addClass('float-right');
                    });
                }
            });
    }
});

document.addEventListener('change', e => {
    if (e.target.id === 'vatNumber') {
        let vatNumberVal = e.target.value.replace(/\s/g, '');
        e.target.value = vatNumberVal;
    }
});
